import Axios from "@/plugins/Axios";

export class PlanosBimestraisService {
  async planoBimestral(gestaoDeAulaId, bimestre) {
    const response = await Axios().get(
      `planos-bimestrais/plano-bimestral/${gestaoDeAulaId}/${bimestre}`
    );

    return response.data;
  }

  async createOrUpdate(plano) {
    const response = await Axios().post(`planos-bimestrais/criar-plano-bimestral`, {
      plano,
    });
    return response.data;
  }

  async planoBimestralInfanil(gestaoDeAulaId, bimestre) {
    const response = await Axios().get(
      `planos-bimestrais/plano-bimestral-infantil/${gestaoDeAulaId}/${bimestre}`
    );
    return response.data;
  }

  async createOrUpdateInfantil(plano) {
    const response = await Axios().post("planos-bimestrais/criar-plano-bimestral-infantil", {
      plano,
    });
    return response.data;
  }
}
export default new PlanosBimestraisService();
